<script>
export default {
  name: 'ReviewStatementContainer',
  props: {
    pros: {
      type: Array,
      required: true,
    },
    cons: {
      type: Array,
      required: true,
    },
  },
};
</script>

<template>
  <v-card-text class="mx-2">
    <v-layout>
      <v-flex>
        <h3>{{ $t('review.reviewStatementContainer.pros')}}</h3>
        <br>
        <ul v-for="pro in pros" :key="pro.id">
          <li> {{ pro.text }} </li>
        </ul>
        <p v-if="!pros.length">{{ $t('review.reviewStatementContainer.noPros')}}</p>
      </v-flex>
      <v-flex xs6>
        <h3>{{ $t('review.reviewStatementContainer.cons')}}</h3>
        <br>
        <ul v-for="con in cons" :key="con.id">
          <li> {{ con.text }} </li>
        </ul>
        <p v-if="!cons.length">{{ $t('review.reviewStatementContainer.noCons')}}</p>
      </v-flex>
    </v-layout>
  </v-card-text>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewStatementContainer.vue